import React, { createContext, useState, useContext, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import auth, { login, logout } from '../firebase';

const ALLOWED_DOMAIN = 'cloudcompliance.app';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser && !firebaseUser.email?.endsWith(`@${ALLOWED_DOMAIN}`)) {
        await signOut(auth);
        setUser(null);
        setGroups(null);
        setAuthError('Not authorized.');
      } else if (firebaseUser) {
        setUser(firebaseUser);
        setAuthError(null);
        // Fetch group memberships from server
        try {
          const token = await firebaseUser.getIdToken();
          const res = await fetch('/api/me', {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (res.ok) {
            const data = await res.json();
            setGroups(data.groups);
          }
        } catch (err) {
          console.error('Failed to fetch groups:', err);
        }
      } else {
        setUser(null);
        setGroups(null);
        setAuthError(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    user,
    groups,
    login,
    logout,
    authError,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 